const navSlider = (container, options = 0) => {

    const $container = $(container);

    const defaults = {
        items: 2,
        loop: false,
        margin: 18,
        nav: true,
        navSpeed: 700,
        dragEndSpeed: 500,
        navText: [
            '<img src="/wp-content/themes/classy/dist/img/icons/slider-arrow-circle.svg" alt="left"/>',
            '<img src="/wp-content/themes/classy/dist/img/icons/slider-arrow-circle.svg" alt="right"/>'
        ],
        responsive: {

            992 : {
                items: 2
            },

            768 : {
                items: 1
            },

            0 : {
                items: 1
            }
        }
    };

    options = Object.assign(defaults, options);

    $container.owlCarousel(options);

    $container.find('.owl-nav').removeClass('disabled').appendTo($container.parents('.js-owl-wrap'));
    $container.on('changed.owl.carousel', function(event) {
        $(this).find('.owl-nav').removeClass('disabled');
    });

};

export default navSlider;
